import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { Command, CommandEmpty, CommandGroup, CommandItem } from '@/components/ui/command';

// eslint-disable-next-line react/display-name
export const MentionList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index) => {
    const item = props.items[index];
    if (item) props.command(item);
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => {
    setSelectedIndex(0);
  }, [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div className="bg-popover text-popover-foreground z-50 w-64 rounded-md border shadow-md">
      <Command>
        <CommandGroup>
          {props.items.length > 0 ? (
            props.items.map((item, index) => (
              <CommandItem
                key={item.key || index}
                onSelect={() => selectItem(index)}
                className={index === selectedIndex ? 'bg-accent text-accent-foreground' : ''}
              >
                <div className="flex flex-col text-left">
                  <span className="text-primary text-sm font-medium">{item.name}</span>
                  <span className="text-muted-foreground text-xs">@{item.key}</span>
                </div>
              </CommandItem>
            ))
          ) : (
            <CommandEmpty>No results</CommandEmpty>
          )}
        </CommandGroup>
      </Command>
    </div>
  );
});
